var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// chartjs/chart-js.ts
import "@adornis/base/utilTypes.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { Chart } from "chart.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { state } from "lit/decorators/state.js";
import { ref } from "lit/directives/ref.js";
import { fromEvent } from "rxjs";
import { takeUntil } from "rxjs/operators";
var BaseChart = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.options = {};
  }
  styles() {
    return [
      {
        ".chart-size": {
          position: "relative"
        }
      }
    ];
  }
  connectedCallback() {
    super.connectedCallback();
    fromEvent(window, "resize").pipe(takeUntil(this.disconnected)).subscribe(() => {
      if (this.chart)
        this.chart.resize();
    });
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (!this.ctx && this.canvas && this.data) {
      this.ctx = this.canvas.getContext("2d");
      this.createChartInstance(this.ctx, this.data, this.options);
    }
    if (this.chart && this.data) {
      this.chart.data = this.data;
      this.chart.options = this.options;
      this.chart.update();
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.chart) {
      this.chart.destroy();
      this.chart = void 0;
    }
  }
  createChartInstance(ctx, data, options) {
    if (!this.type)
      throw new Error("Extending BaseChart needs to set type");
    if (!this.chart)
      this.chart = new BaseChart.Chart(ctx, {
        type: this.type,
        data,
        options
      });
  }
  render() {
    return html`
      <div class="chart-size">
        <canvas ${ref((e) => this.canvas = e)}></canvas>
      </div>
    `;
  }
};
BaseChart.Chart = Chart;
__decorateClass([
  state()
], BaseChart.prototype, "data", 2);
__decorateClass([
  state()
], BaseChart.prototype, "options", 2);
BaseChart = __decorateClass([
  customElement("chart-js")
], BaseChart);
export {
  BaseChart as default
};
